/** @format */

export enum TransactionVariant {
    CASH_PURCHASE = 'CASH_PURCHASE',
    PART_EXCHANGE = 'PART_EXCHANGE',
    PART_REFUND = 'PART_REFUND',
    ORDER = 'ORDER',
    NOT_FOUND = 'NOT_FOUND',
    RETURN = 'RETURN',
}

export enum PromotionSummaryType {
    UNDEFINED = 'UNDEFINED',
    DISCOUNT = 'DISCOUNT',
    BONUS = 'BONUS',
    SHIPMENT = 'SHIPMENT',
    COLLECTION = 'COLLECTION',
}
export enum AdjustedLineItemType {
    NOT_RECEIVED = 'NotReceived',
    UNEXPECTED = 'Unexpected',
    CORRECTED = 'Corrected',
    RETURNING = 'Returning',
}
export enum PaymentGatewayType {
    BRAINTREE = 'BRAINTREE',
    STRIPE = 'STRIPE',
    MPB = 'MPB',
} /** @format */

export enum PaymentMethodType {
    CARD = 'CARD',
    PAYPAL = 'PAYPAL',
    IDEAL = 'IDEAL',
    EPS = 'EPS',
    BANCONTACT = 'BANCONTACT',
    SELL_BALANCE = 'SELL_BALANCE',
} /** @format */

export enum CheckoutType {
    PAYPAL = 'paypal',
    PAYPAL_CREDIT = 'paypalCredit',
    CARD = 'card',
    IDEAL = 'ideal',
    EPS = 'eps',
    BANCONTACT = 'bancontact',
    BALANCE = 'balance',
}
